var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"font-size":"0.875rem"}},[_vm._v(" "+_vm._s(_vm.footerValue)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }